import { Component, OnInit } from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';
import { ResourceModel } from '../../../../core/models/resources/resource.model';
import { NotificationsService } from '../../../../service/services/misc/notifications/notifications.service';
import {firstValueFrom, Observable} from 'rxjs';
import {Utils} from "../../../../core/helpers/Utils";

@Component({
    selector: 'move-failed-error-message-dialog',
    templateUrl: './move-failed-error-message-dialog.component.html',
    styleUrls: ['./move-failed-error-message-dialog.component.scss'],
    standalone: false
})
export class MoveFailedErrorMessageDialogComponent implements OnInit {
    resource: ResourceModel;
    type: string;
    title: string;
    generalErrorMsg: string;
    errorMsgMoreDetails: string;
    loading = false;
    showMoreDetails = false;
    viewDetailsTextVisible = true;

    retryFunc: () => Observable<any>;

    constructor(
		public dialogRef: DialogRef,
		private notificationsService: NotificationsService,
    ) {}

    ngOnInit(): void {
        let data = this.dialogRef.data;
        this.resource = data.resource;
        this.generalErrorMsg = data.msg;
        this.errorMsgMoreDetails = data.errorMsg;
        this.retryFunc = data.retryFunc;
    }

    viewErrorDetails() {
        this.viewDetailsTextVisible = false;
        this.showMoreDetails = true;
    }

    async onRetry() {
        try {
            await firstValueFrom(this.retryFunc());
            this.onSuccess();
        } catch (e: any) {
            this.viewDetailsTextVisible = true;
            this.showMoreDetails = false;
            this.errorMsgMoreDetails = e.message;
        } finally {
            this.loading = false;
            this.dialogRef.loading(false);
        }
    }

    onSuccess() {
        this.dialogRef.close();
    }

    onCopy() {
        Utils.copyToClipboard(this.errorMsgMoreDetails);
        this.notificationsService.showMessageToast(
            'Error details copied to the clipboard'
        );
    }

    onClose() {
        this.dialogRef.close();
    }

    validate() {
        return !this.loading;
    }
}